<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label" v-if="residentTags.length > 0">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["which_car"] }}</p>
      </div>
      <p class="content_title" v-if="residentTags.length > 0">
        {{ this.$store.getters.TRANSLATIONS["select_tag_car"] }}
      </p>
      <p class="content_title_center" v-if="residentTags.length === 0">
        {{ this.$store.getters.TRANSLATIONS["no_tags_found"] }}
      </p>
      <div
        class="car"
        v-for="item in residentTags"
        :key="item.id"
        v-on:click="next(item)"
      >
        <div class="model">
          <button class="button">
            {{ item.vehicle.make || "" }} {{ item.vehicle.model || "" }}
            {{ item.vehicle.color || "" }}
          </button>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!loading"></div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    } else {
      this.residentTags = this.$store.getters.RESIDENTS_TAGS;
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      requestType: "PARKENDA",
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      residentTags: [],
      next: (tag) => {
        this.$store.dispatch("SET_SELECTED_RESIDENT_TAG", tag);
        this.$router.push("/tagDetails");
      },
      back: () => {
        this.$router.go(-1);
      },
      icon: require("@/assets/icon_back.png"),
      nextIcon: require("@/assets/nextArrowIos.jpg")
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.button {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/Residential/SelectTag.vue